import { render, staticRenderFns } from "./BlankView.vue?vue&type=template&id=24cbf9c4&scoped=true"
import script from "./BlankView.vue?vue&type=script&lang=js"
export * from "./BlankView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cbf9c4",
  null
  
)

export default component.exports